var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15             C20 15, 60 15, 75 15            C85 15, 85 25, 85 35            C85 45, 85 65, 85 80            C85 90, 80 90, 70 90            C60 90, 30 90, 30 90            L20 90 Z",
    fill: "#E50914"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25            C30 25, 50 25, 65 25            C75 25, 75 30, 75 40            C75 50, 75 60, 75 75            C75 82, 70 80, 62 80            C54 80, 40 80, 40 80            L30 80 Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 52,
    r: 15,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.646f3126d4bfa377c5366efafd6c7ed9.svg";
export { ForwardRef as ReactComponent };